import BaseCollection from 'common/models/base/collection';
import collectionMixin from 'common/models/mixins/collection';
import FaxLine from './fax-line';

export default BaseCollection.extend({
  /**
   */

  mixins: [collectionMixin],

  /**
   */

  apiEndpointAlias: 'faxLines',

  /**
   */

  createModel(properties) {
    properties.notifier = this.notifier;
    properties.user = this.user;
    return FaxLine.create(properties);
  },

  /**
   */

  addFaxLine(properties) {
    return this.createModel(properties).insert();
  },
});
